<template>
    <div class="main">

        <div class="title_div">
            <span class="iconbiaoqian1 iconfont"></span>
            <span class="title_txt">文件处理工具</span>

        </div>
        <div class="tool_div">

            <div class="pdf_card" v-for="(item, i) in tools_list" :key="i" @click="click_item(item,i)">
                <div class="tools_img">
                    <img :src="item.icon" alt="" color="tools_img" style="width:100%;height:100%">
                </div>
                <div>
                    <div class="tools_name">
                        {{ item.name }}
                    </div>

                    <div class="tools_detail">
                        {{ item.detail }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { open_new_page, http, get_browser_id } from "@/utils/http";

export default {
    name: 'tools',
    data() {
        return {
            tools_list: [
                {
                    name: 'PDF压缩',
                    icon: require('@/assets/image/tools/pdf.png'),
                    detail: "可以将几十至上百兆的PDF文件压缩到10M以内",
                    src:"https://project.daxiangsys.com/tools/compress/pdf"
                }
            ]
        }
    },
    methods:{
        click_item(item,i){
            open_new_page(item.src)
        }
    }
}
</script>

<style scoped>
.tools_img {
    width: 50px;
    height: 50px;
    flex-shrink: 0;
    margin-right: 15px;
}

.iconbiaoqian1 {
    color: #0466dd;
    font-size: 20px;
    margin-right: 3px;
}

.title_txt {
    font-size: 15px;
    font-weight: 600;
    color: #000000;
}

.title_div {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

.main {
    padding: 20px;
    width: calc(100vw - 120px);
    height: 100%;
    background-color: #ececec;
}

.tool_div {
    display: flex;
    flex-wrap: wrap;
}

.tools_detail{
    font-size: 13px;
    color:#7c7c7c
}

.tools_name {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 5px;
}

.pdf_card {
    margin: 0 10px 10x 0;
    border-radius: 8px;
    width: 300px;
    position: relative;
    padding: 10px;
    background-color: #fff;
    border: 1px solid #eeeeee;
    box-shadow: 0 0 3px #cedce5;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.pdf_card:hover {
    background-color: #0466dd;
    color: #fff
}

.pdf_card:hover .tools_detail{
    color:#fff
}
</style>